<template>
  <chart-card :chart-data="chartData" chart-type="Bar" :chart-options="chartOptions">
    <template slot="header">
      <div class="row">
        <div class="col-8">
          <h4 class="card-title">Boşaltma Trendi</h4>
          <p class="card-category">Zaman içindeki kumbara boşaltma sayısı</p>
        </div>
        <div class="col-4" style="text-align: right;">
          <a-radio-group v-model="granularity" @change="reload" size="small">
            <a-radio-button value="week">Haftalık</a-radio-button>
            <a-radio-button value="month">Aylık</a-radio-button>
          </a-radio-group>
        </div>
      </div>
    </template>
    <template slot="footer">
      <div class="stats">
        <i class="fa fa-clock-o"></i> {{ points.length }} veri noktası
      </div>
    </template>
  </chart-card>
</template>

<script>
import { mapState } from 'vuex'
import ChartCard from 'src/components/Cards/ChartCard.vue'

export default {
  components: { ChartCard },
  computed: {
    ...mapState({
      points: (state) => state.Reports.unload_trend,
    }),
    chartData() {
      return {
        labels: this.points.map((p) => p.period),
        series: [this.points.map((p) => p.count)],
      }
    },
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$store.dispatch('Reports/requestUnloadTrend', this.granularity)
    },
  },
  data() {
    return {
      granularity: 'week',
      chartOptions: {
        seriesBarDistance: 10,
        axisX: { showGrid: false },
        height: '245px',
      },
    }
  },
}
</script>
